import { useHistory } from 'react-router';

import useEffectOnEnvironmentChange from 'lib/hooks/useOnEnvironmentChange';

/**
 * useRedirectOnEnvironmentChange
 *
 * Effect hook that runs when currentEnvironment changes. When it does, boots
 * you back to the specified parent route. Should be used in show views, as the
 * entity for the current page generally should not be viewable once the user
 * presses the sandbox toggle.
 */
export default function useRedirectOnEnvironmentChange(destination = '/dashboard'): void {
  const history = useHistory();

  useEffectOnEnvironmentChange(() => {
    history.push(destination);
  });
}
